import React from "react"
import { connect } from "react-redux"
import { CircularProgress } from "@material-ui/core"
import CampaignPopupPerformanceByCountryChart from "./charts/performanceByCountryChart"
import CampaignPopupPerformanceByCountryList from "./lists/performanceByCountryList"
import {
  campaignPopupLoading,
  fetchCampaignPerformanceByCountryAsync,
  resetCampaignPopupTable,
} from "../campaignPopupActions"
import RequestsService from "../../api/requestsService"

class CampaignPopupPerformanceByCountry extends React.Component {
  componentDidMount() {
    this.getPerformanceByCountry()
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (
      JSON.stringify(prevProps.datePickerDates.startDate) !== JSON.stringify(this.props.datePickerDates.startDate) ||
      JSON.stringify(prevProps.datePickerDates.endDate) !== JSON.stringify(this.props.datePickerDates.endDate)
    ) {
      this.getPerformanceByCountry()
    }
  }

  componentWillUnmount() {
    this.props.dispatch(resetCampaignPopupTable("performanceByCountry"))
    RequestsService.cancelRequest("performance-by-country-request")
  }

  getPerformanceByCountry = () => {
    RequestsService.cancelRequest("performance-by-country-request")
    this.props.dispatch(campaignPopupLoading())
    this.props.dispatch(
      fetchCampaignPerformanceByCountryAsync(
        this.props.campaign,
        this.props.datePickerDates.startDate,
        this.props.datePickerDates.endDate
      )
    )
  }

  render() {
    let loadingIndicator = null
    let countriesChartData = []
    let performanceByCountry = null

    if (this.props.isLoading) {
      loadingIndicator = (
        <div className="campaign-popup-loading d-flex align-items-center justify-content-center">
          <CircularProgress className="loader" size={40} />
        </div>
      )
    } else {
      countriesChartData = this.props.performanceByCountry.slice(
        (this.props.currentPage - 1) * this.props.itemsPerPage,
        this.props.currentPage * this.props.itemsPerPage
      )

      performanceByCountry = (
        <div className="campaign-popup-performance-by-country">
          <CampaignPopupPerformanceByCountryChart data={countriesChartData} campaign={this.props.campaign} />
          <CampaignPopupPerformanceByCountryList />
        </div>
      )
    }

    return (
      <>
        {loadingIndicator}
        {performanceByCountry}
      </>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    campaign: state.campaignPopupV2.campaign,
    datePickerDates: {
      startDate: state.campaignPopupV2.datePickerDates.startDate,
      endDate: state.campaignPopupV2.datePickerDates.endDate,
    },
    isLoading: state.campaignPopupV2.isLoading,
    performanceByCountry: state.campaignPopupV2.performanceByCountry.dataForTable,
    itemsPerPage: state.campaignPopupV2.performanceByCountry.itemsPerPage,
    currentPage: state.campaignPopupV2.performanceByCountry.currentPage,
  }
}

export default connect(mapStateToProps)(CampaignPopupPerformanceByCountry)
